import { Layout } from 'antd';
import { FC, ReactElement } from 'react';
import style from './Content.style.module.scss';

const Content: FC<{ children: ReactElement }> = ({ children }) => (
  <Layout.Content className={style['content']}>{children}</Layout.Content>
);

export default Content;
